export enum ServiceEmissionType {
  USE_OF_SERVICES_1 = 'USE_OF_SERVICES_1',
  USE_OF_SERVICES_OTHER = 'USE_OF_SERVICES_OTHER',
}

export const ServiceEmissionTypeOptions = Object.values(ServiceEmissionType);
